module.exports = __webpack_public_path__ + "static/media/calendar-star.03815faf.svg";